import React, { useState, useEffect,useRef } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
import Barcode from 'react-barcode';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import BarcodePage from "./barcode";
import ReactToPrint from 'react-to-print';

import "../../../../App.css";
 const pageSytle=`
 @page {
  size: 90mm 16mm;
 };

 @media all {
  .pageBreak 
  {
    display:none
  }
 };

 @media print {

  .pageBreak{
    page-break-before: always;  
  }
 }
 `;
 
/*


*/

const TableData = (props) => {

 const [BarcodeData, setBarcodeData, BarcodeDataRef] = useStateRef([]);
   
  useEffect(() => {
 innitialSetValue();

  }, []);
  

  

const ref=useRef();

  function innitialSetValue() {

    GetBarCode(props.TagId);
 
  }

  function printDiv() {
    var btn=document.getElementById("cmdDetSave");

    
  }


  async function GetBarCode(EditId){
	  try
    {
     
      let postData = {
        TagId: EditId
    }

    const results = await apiService.postCall("taggedscreen/GetBarCode",postData);


   if (results != "-1") {
     
   let Barcode=results.data.dtBarcode;

   setBarcodeData(Barcode[0][0]);
   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/plussing/taggedscreen/list');
  };

  return (
    <>
    

      <Row className="">
       
           <div id="printarea" ref={ref}>
          <table>
<tr>
  <td id="s1">{BarcodeDataRef.current.ProdName}</td>
  <td id="s3" rowspan="4"></td>
  <td id="s2">{BarcodeDataRef.current.TagKey}</td>
  <td id="s3" rowspan="4"></td>
</tr>
<tr>
  <td id="s1">Net.Wt: {BarcodeDataRef.current.NetWt}g</td>
  <td id="s4">Wt.{BarcodeDataRef.current.NetWt}g</td>
</tr>
<tr>
  <td id="s1">{BarcodeDataRef.current.ItemName}</td>
  <td id="s4" rowspan="2"><Barcode value={BarcodeDataRef.current.TagNo} height={10} marginTop={-1} marginBottom={-1} width={1} displayValue={false} fontSize={10} format="CODE39" />
</td>
</tr>
<tr>
  <td></td>
</tr>
</table>
</div>
 
<ReactToPrint 
trigger={()=>
  <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" >PRINT</Button>
		                   </div>
                       }
content={()=>ref.current}
pageStyle={pageSytle}
/>

      </Row >
    </>
  );
};

export default TableData;
